import React, { useEffect } from 'react';
import Footer from '../Footer/Footer';
import './OurProcess.css';

const OurProcess = () => {
    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll('.section-card');
            elements.forEach(element => {
                const position = element.getBoundingClientRect();
                if (position.top < window.innerHeight && position.bottom >= 0) {
                    element.classList.add('animate');
                }
            });
        };

        window.addEventListener('scroll', handleScroll);

        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div>
            <div className="ds-marketing about-us-container">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="progress-title">
                                {/* Was "Our Progress" — a typo on a page whose
                                    route, nav label and content are all
                                    "Our Process". */}
                                <h1>Our Process</h1>
                                <p>Discover the steps we take to verify your property</p>
                            </div>

                            {/* First Row of Cards */}
                            <div className="row">
                                <div className="col-md-4">
                                    <section className="section-op">
                                        <div className="section-card">
                                            <div className="card-icon">🔑</div>
                                            <h2 className="section-op-title">Login/Register</h2>
                                            <p>Create an account on DoCity with our simple registration process and register your property of interest through the verification form.</p>
                                        </div>
                                    </section>
                                </div>
                                <div className="col-md-4">
                                    <section className="section-op">
                                        <div className="section-card">
                                            <div className="card-icon">📄</div>
                                            <h2 className="section-op-title">Upload Documents</h2>
                                            <p>Upload documents related to the property, including the seller and draft sale deeds, land use certificates, and link documents.</p>
                                        </div>
                                    </section>
                                </div>
                                <div className="col-md-4">
                                    <section className="section-op">
                                        <div className="section-card">
                                            <div className="card-icon">💵</div>
                                            <h2 className="section-op-title">Acknowledgement</h2>
                                            <p>Pay a nominal processing fee to receive an acknowledgement and have a civil engineer assigned to process your request.</p>
                                        </div>
                                    </section>
                                </div>
                            </div>

                            {/* Second Row of Cards */}
                            <div className="row">
                                <div className="col-md-4">
                                    <section className="section-op">
                                        <div className="section-card">
                                            <div className="card-icon">💬</div>
                                            <h2 className="section-op-title">Communication</h2>
                                            <p>Communicate with the engineer through chat or have them contact you directly to address any queries.</p>
                                        </div>
                                    </section>
                                </div>
                                <div className="col-md-4">
                                    <section className="section-op">
                                        <div className="section-card">
                                            <div className="card-icon">🛠️</div>
                                            <h2 className="section-op-title">Processing</h2>
                                            <p>The civil engineer begins processing the documents and assessing the land in question.</p>
                                        </div>
                                    </section>
                                </div>
                                <div className="col-md-4">
                                    <section className="section-op">
                                        <div className="section-card">
                                            <div className="card-icon">🔍</div>
                                            <h2 className="section-op-title">Review</h2>
                                            <p>The expert reviews legal issues and discrepancies to ensure smooth transactions and future plans.</p>
                                        </div>
                                    </section>
                                </div>
                            </div>

                            {/* Third Row of Cards */}
                            <div className="row">
                                <div className="col-md-4">
                                    <section className="section-op">
                                        <div className="section-card">
                                            <div className="card-icon">📈</div>
                                            <h2 className="section-op-title">Report</h2>
                                            <p>The final report, including property details and fair market value, will be uploaded to the portal.</p>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default OurProcess;

